import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { useEffect, useState } from 'react';

const LibraryHeaderContent = ({ searchValue, setSearchValue, addedExercisesLength, t, setPanelCreateDialogVisibility, searchFilterSectionVisibility, contentExercisesIsEmpty, setSearchFilterSectionVisibility,cartIconRef }: any) => {

    const [animate, setAnimate] = useState(false);

    useEffect(() => {
        if (addedExercisesLength > 0) {
            setAnimate(true);
            const timer = setTimeout(() => setAnimate(false), 400);
            return () => clearTimeout(timer);
        }
    }, [addedExercisesLength]);

    return (
        <Card className='library-card' style={{ borderRadius: "24px", position: "relative", backgroundColor: "#e7e7f0", boxShadow: "none" }}>
            <div className="flex justify-content-between align-items-center">
                <div className="flex align-items-center justify-content-center">
                    {!searchFilterSectionVisibility && (
                        <Button onClick={() => setSearchFilterSectionVisibility(true)} style={{ backgroundColor: "transparent", border: "none", borderRadius: '8px', paddingTop: "0.75rem", paddingBottom: "0.75rem", paddingLeft: "0.75rem", paddingRight: "0.75rem" }} className="flex justify-content-center align-items-center opacity-60">
                            <div className="flex flex-column align-items-center gap-1 justify-content-center">
                                <img src="/goBack.svg" style={{ transform: "rotate(180deg)" }} width={20} />
                                <span className='font-normal text-xs' style={{ color: "#2D3967" }}>{t("filters")}</span>
                            </div>
                        </Button>
                    )}
                    <p className='text-xl mx-2' style={{ color: "#727A99" }}>{t("exerciseLibrary")}</p>
                </div>
                <div className="flex gap-3 align-items-center">
                    {!contentExercisesIsEmpty() && (
                        <IconField iconPosition="right" className='w-25rem' >
                            <InputIcon className="pi pi-search" />
                            <InputText className='w-full' style={{ borderRadius: "10px" }} value={searchValue}
                                onChange={(e: any) => setSearchValue(e.target.value)} placeholder={t("searchExercise")} />
                        </IconField>
                    )}
                    <Button style={{ backgroundColor: "#2D3967", border: "none", width: '12.5rem', height: '3rem', borderRadius: '10px' }} onClick={() => setPanelCreateDialogVisibility((prev: any) => !prev)}>
                        <div className="flex justify-content-center align-items-center w-full" ref={cartIconRef}>
                            <span className='font-bold text-xl'>{t("myPanels")}</span>
                            <Badge
                                value={addedExercisesLength}
                                severity="danger"
                                className={`flex justify-content-center align-items-center ${animate ? 'badge-animate' : ''}`}
                                style={{ width: '1.75rem', height: '1.75rem' }}
                            />
                        </div>
                    </Button>
                </div>
            </div>
        </Card>

    )
}

export default LibraryHeaderContent;
